import styled from 'styled-components';
import {
  Box, Chip, Typography,
} from '@material-ui/core';

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 60%;
`;

export const FlexBoxRight = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const SquaredChip = styled(Chip).attrs({
  size: 'small',
})`
  color: ${(props: { type: any }) => props.type.primary} !important;
  background-color: ${(props: { type: any }) => props.type.secondary} !important;
  border-radius: 4px !important;
  text-transform: uppercase;
  font-weight: 500;
  width: 65px;
  
`;

export const DetailWrapper = styled(Box)`
  margin-top: 32px;
`;

export const DetailItemRow = styled(Box)`
  padding: 10px 0;
  column-gap: 15px;
  display: flex;
  justify-content: space-between;
  min-height: 40px;
  align-items: center;
`;

export const DetailItemTitle = styled(Typography)`
  white-space: nowrap;
  align-self: flex-start;
  font-size: 0.9rem !important;
`;

export const DetailItemDescription = styled(DetailItemTitle)`
  white-space: inherit;
  text-align: end;
  font-size: 0.8rem;
`

export const ChipWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;
